import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import MarketingLayout from "@/components/marketing/MarketingLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import CoursesPage from "@/pages/CoursesPage";
import GalleryPage from "@/pages/GalleryPage";
import EventsPage from "@/pages/EventsPage";
import TestimonialsPage from "@/pages/TestimonialsPage";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import { Loader2 } from "lucide-react";

function AdminGate() {
  const { admin, loading } = useAuth();
  if (loading || admin === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-purple">
        <Loader2 className="h-8 w-8 animate-spin text-gold" />
      </div>
    );
  }
  return admin ? <AdminDashboard /> : <AdminLogin />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ContentProvider>
            <Routes>
              <Route element={<MarketingLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/courses" element={<CoursesPage />} />
                <Route path="/gallery" element={<GalleryPage />} />
                <Route path="/events" element={<EventsPage />} />
                <Route path="/testimonials" element={<TestimonialsPage />} />
                <Route path="/contact" element={<Contact />} />
              </Route>
              <Route path="/admin" element={<AdminGate />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </ContentProvider>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
